import { useEffect, useState } from 'react';
import moment from 'moment';
import {
  Box,
  capitalize,
  ClickAwayListener,
  IconButton,
  Link,
  Popper,
  Typography,
} from '@material-ui/core';
import { InfoOutlined as InfoOutlinedIcon } from '@material-ui/icons';
import { CalendarIcon, PersonalTemplatesIcon, ErrorNotificationIcon } from '@images/icons';
import { translate } from '@utils';
import { SubmissionEntityInterface } from '@types';
import { environment } from '@env';

import './index.scss';
import { LangEnum } from '@enums';

interface Props {
  submission: SubmissionEntityInterface;
}

export const DetailsInfo = ({ submission }: Props) => {
  const [lang, setLang] = useState(LangEnum.ENG);
  const [anchorEl, setAnchorEl] = useState(null);

  const isDeprecated = false;

  useEffect(() => {
    if (submission?.origin?.lang) {
      setLang(submission.origin.lang);
    }
  }, [submission]);

  const handleClick = (event) => {
    setAnchorEl(anchorEl ? null : event.currentTarget);
  };

  const handleClickAway = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? 'simple-popper' : undefined;

  return (
    <ClickAwayListener onClickAway={handleClickAway}>
      <div data-testid="di-information-button">
        <IconButton
          aria-describedby={id}
          data-testid="di-button-info"
          type="button"
          onClick={handleClick}
          className={isDeprecated ? 'information__popper_error' : ''}
        >
          <InfoOutlinedIcon />
        </IconButton>
        <Popper
          data-testid="di-popper-container"
          className="details-info-popper"
          id={id}
          open={open}
          anchorEl={anchorEl}
        >
          <div className="information__popper">
            {isDeprecated && (
              <Box className="information__popper_error">
                <ErrorNotificationIcon className="information__popper_icon" />
                <Typography>{`${translate('submission_is_deprecated')}`}</Typography>
              </Box>
            )}

            <Box className="information__popper_line calendar">
              <CalendarIcon className="information__popper_icon" />
              <Typography>{`${translate('last_modified', lang)}:`}</Typography>
              <Typography className="information__popper_text">
                {moment(Date.parse(submission.updatedAt?.toString())).format('DD.MM.YYYY')}
              </Typography>
            </Box>
            {(submission.editedBy || submission.owner) && (
              <Box className="information__popper_line person">
                <PersonalTemplatesIcon className="information__popper_icon" />
                <Typography>{`${translate('author_of_changes', lang)}:`}</Typography>
                <Typography className="information__popper_text">
                  <Link
                    id="di-owner-link"
                    href={`${environment.WOD_URL}/employees/${
                      submission.editedBy
                        ? submission.editedBy.internalId
                        : submission.owner.internalId
                    }`}
                    target="_blank"
                    rel="noreferrer"
                  >
                    {submission.editedBy
                      ? submission.editedBy[`fullName${capitalize(lang.toLowerCase())}`]
                      : submission.owner[`fullName${capitalize(lang.toLowerCase())}`]}
                  </Link>
                </Typography>
              </Box>
            )}
          </div>
        </Popper>
      </div>
    </ClickAwayListener>
  );
};
